import { Shield } from 'lucide-react';

const WelcomeScreen = ({ onStart }) => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
    <div className="w-full max-w-2xl">
      <div className="card text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield size={48} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            eKYC Verification
          </h1>
          <p className="text-gray-600 mb-6">
            Complete your identity verification in a few simple steps
          </p>
        </div>

        <div className="space-y-4 mb-8 text-left">
          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
              1
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">Upload NID Images</h3>
              <p className="text-sm text-gray-600">Upload both front and back images of your NID card</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
              2
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">Review OCR Results</h3>
              <p className="text-sm text-gray-600">Review extracted information from your NID card</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
            <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">
              3
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">Liveness Check</h3>
              <p className="text-sm text-gray-600">Complete simple face movements to verify your identity</p>
            </div>
          </div>
        </div>

        <button
          onClick={onStart}
          className="btn-primary w-full text-lg"
        >
          Start Verification
        </button>

        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800">
            <strong>Note:</strong> Please ensure you have your NID card with you and are in a well-lit area.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default WelcomeScreen;
